(() => {
  const validOffer = element => {
    if (!element || element.dataset.enabled !== 'true') return null;
    const code = (element.dataset.code || '').trim();
    const percentage = Number(element.dataset.percentage);
    return code && Number.isFinite(percentage) && percentage >= 1 && percentage <= 90
      ? { code, percentage } : null;
  };
  const discounted = (price, percentage) => Math.round(price * (100 - percentage) / 100);
  const money = (amount, format) => {
    const match = format.match(/\d[\d.,' \u00a0\u202f]*\d/);
    if (!match) return format;
    const sample = match[0];
    const decimal = sample.match(/([.,])89$/)?.[1];
    const thousands = sample.match(/^1([^\d]*)234/)?.[1] || '';
    const parts = (amount / 100).toFixed(decimal ? 2 : 0).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return format.replace(sample, parts.join(decimal || ''));
  };
  let scheduled = false;
  const refresh = () => {
    scheduled = false;
    const main = document.querySelector('main, [role="main"]');
    const sections = main ? [...main.querySelectorAll('page-coupon-offer')] : [];
    const active = sections.find(section => validOffer(section));
    const offer = validOffer(active);
    for (const section of sections) section.hidden = section !== active;
    if (main) {
      for (const message of main.querySelectorAll('[data-page-coupon-inline]')) message.hidden = !offer;
      for (const code of main.querySelectorAll('[data-page-coupon-code]')) code.textContent = offer ? offer.code : '';
    }
    if (main) for (const target of main.querySelectorAll('page-coupon-price')) target.update(offer);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(refresh);
  };
  class PageCouponPrice extends HTMLElement {
    connectedCallback() {
      this.signature = null;
      schedule();
    }
    update(offer) {
      const original = this.querySelector('[data-coupon-default]');
      const output = this.querySelector('[data-coupon-output]');
      if (!original || !output) return;
      if (this.closest('[data-coupon-exclude], cart-drawer, #Cart-Drawer, #mini-cart')) offer = null;
      const price = Number(this.dataset.price);
      if (!Number.isFinite(price) || price <= 0) offer = null;
      const signature = offer ? JSON.stringify(offer) : '';
      if (signature === this.signature) return;
      this.signature = signature;
      original.hidden = Boolean(offer);
      output.hidden = !offer;
      if (!offer) {
        output.replaceChildren();
        return;
      }
      const comparison = Math.max(price, Number(this.dataset.comparison) || price);
      const finalPrice = discounted(price, offer.percentage);
      const format = this.dataset.format;
      const content = this.querySelector('template').content.cloneNode(true);
      for (const element of content.querySelectorAll('[data-coupon-money]')) {
        const type = element.dataset.couponMoney;
        const amount = type === 'comparison' ? comparison : type === 'maximum'
          ? discounted(Number(this.dataset.maximum) || price, offer.percentage)
          : type === 'unit' ? discounted(Number(this.dataset.unit), offer.percentage) : finalPrice;
        element.innerHTML = money(amount, format);
      }
      for (const element of content.querySelectorAll('[data-coupon-code]')) element.textContent = offer.code;
      if (this.dataset.theme === 'vollyc') {
        const root = document.createElement('span');
        root.innerHTML = original.innerHTML;
        const priceRoot = root.querySelector('.price');
        if (this.dataset.kind === 'badge') {
          this.updateBadge(root, comparison, finalPrice, format);
          output.replaceChildren(...root.childNodes);
          return;
        }
        const regular = priceRoot.querySelector(':scope > ins');
        priceRoot.querySelector(':scope > del')?.remove();
        regular.replaceWith(content);
        const unit = priceRoot.querySelector('.unit-price > span');
        if (unit && this.dataset.unit) unit.innerHTML = money(discounted(Number(this.dataset.unit), offer.percentage), format);
        this.updateBadge(root, comparison, finalPrice, format);
        output.replaceChildren(...root.childNodes);
      } else {
        const unit = original.querySelector('.product-item__price-info')?.cloneNode(true);
        if (unit && this.dataset.unit) unit.querySelector('.unit-price-measurement__price').innerHTML = money(discounted(Number(this.dataset.unit), offer.percentage), format);
        output.replaceChildren(content);
        if (unit) output.append(unit);
      }
    }
    updateBadge(root, comparison, price, format) {
      if (this.dataset.available !== 'true') return;
      const container = root.querySelector('.product-card--badges, .badges');
      if (!container) return;
      let badge = container.querySelector('.onsale');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'badge onsale';
        container.append(badge);
      }
      const savings = this.dataset.badgeMode === 'save_amount' ? money(comparison - price, format)
        : `${Math.round((comparison - price) * 100 / comparison)}%`;
      badge.innerHTML = this.dataset.badgeMode === 'sale' ? this.dataset.saleLabel
        : this.dataset.savingsLabel.replace('[[savings]]', savings);
    }
  }
  class PageCouponOffer extends HTMLElement {
    static get observedAttributes() { return ['data-code', 'data-percentage', 'data-enabled']; }
    connectedCallback() { schedule(); }
    disconnectedCallback() { schedule(); }
    attributeChangedCallback() { schedule(); }
  }
  if (!customElements.get('page-coupon-price')) customElements.define('page-coupon-price', PageCouponPrice);
  if (!customElements.get('page-coupon-offer')) customElements.define('page-coupon-offer', PageCouponOffer);
  const main = document.querySelector('main, [role="main"]');
  if (main) new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
      node.nodeType === 1 && (node.matches('page-coupon-offer, page-coupon-price, [data-page-coupon-inline]') || node.querySelector('page-coupon-offer, page-coupon-price, [data-page-coupon-inline]'))
    ))) schedule();
  }).observe(main, { childList: true, subtree: true });
  schedule();
})();
